import { msg } from "../locales/translate.ts";
// Some processing endpoints serialize a Node Buffer inside a JSON data envelope.
// Keep ordinary JSON files intact; unwrap only an explicitly tagged byte buffer.
export const normalizeFileResponseBlob = async (blob: Blob): Promise<Blob> => {
	const prefix = (await blob.slice(0, 256).text()).replace(/^\uFEFF/, "").trimStart();
	if (!prefix.startsWith("{")) return blob;

	let payload: unknown;
	try {
		payload = JSON.parse((await blob.text()).replace(/^\uFEFF/, ""));
	} catch {
		return blob;
	}

	for (let depth = 0; depth < 8 && payload && typeof payload === "object"; depth++) {
		const value = payload as { type?: unknown; data?: unknown };
		if (value.type === "Buffer") {
			if (!Array.isArray(value.data) || !value.data.every(byte => Number.isInteger(byte) && byte >= 0 && byte <= 255)) {
				throw new Error(msg("invalidFileBufferReceivedFromServer"));
			}
			return new Blob([new Uint8Array(value.data)], { type: "application/octet-stream" });
		}
		payload = value.data;
	}
	return blob;
};
